import React from 'react'
import {StyledLogoContainer} from './LogoStyle'
import {Link} from "gatsby";

const Logo = () => {
    return (
        <Link to={'/'}>
            <StyledLogoContainer/>
        </Link>
    )
}

export default Logo
